import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "as-h2h as-scrolling as-scrolling__result-popup"
}

import { ref, computed, getCurrentInstance } from "vue";
import type { IMatch, IH2h } from "~src/interfaces/tennis";
import H2hTab from "~src/components/h2h/tennis/H2hTab.vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";


const __default__ = {};

interface IProps {
  match: IMatch;
  h2h: IH2h;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'NextMatchList',
  props: {
    match: {},
    h2h: {}
  },
  setup(__props: any) {

const props = __props;

const instance: any = getCurrentInstance();
const activeTab = ref("home");

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
};

const isShow = computed(() => {
  if (
    Object.keys(props.h2h).length === 0 ||
    JSON.stringify(props.h2h) === "{}"
  ) {
    return false;
  }
  return true;
});

const tournaments = computed(() => {
  if (instance?.proxy?.gSportType === "volleyball") {
    return props.h2h?.uniqueTournaments ?? [];
  }

  return props.h2h?.tournaments ?? [];
});

const h2hHome = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.future.home)) {
    return [];
  }

  return props.h2h.future.home.filter((item: any) => {
    let check: any = item.status_id === MatchEnum.STATUS_NOT_STARTED;
    return check;
  });
});

const h2hAway = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.future.away)) {
    return [];
  }

  return props.h2h.future.away.filter((item: any) => {
    let check: any = item.status_id === MatchEnum.STATUS_NOT_STARTED;
    return check;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isShow.value)
      ? (_openBlock(), _createBlock(TabsBtn, {
          key: 0,
          tabs: tabs.value,
          activeTab: activeTab.value,
          onChange: changeTab,
          isShowBorder: true
        }, null, 8, ["tabs", "activeTab"]))
      : (_openBlock(), _createBlock(NoData, { key: 1 })),
    (isShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(H2hTab, {
              h2h: h2hHome.value,
              teams: _ctx.h2h.teams,
              competitions: tournaments.value,
              match: _ctx.match,
              tab: "home",
              homeTeamId: _ctx.match.home_team_id
            }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]),
            (h2hHome.value.length === 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, activeTab.value !== 'away']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(H2hTab, {
              h2h: h2hAway.value,
              teams: _ctx.h2h.teams,
              competitions: tournaments.value,
              match: _ctx.match,
              tab: "away",
              homeTeamId: _ctx.match.away_team_id
            }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]),
            (h2hAway.value.length === 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, activeTab.value !== 'home']
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})